import React from 'react'
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from "prop-types";

const CheckboxWrapper = ({ onChange, value, label, ...rest }) => {

    const onCheckboxChange = (e, data) => {
        if (onChange) {
            onChange(data.checked)
        }
    }

    return (
        <Form.Field key="Compare" {...rest}>
            <label>{label}</label>
            <Checkbox
                onChange={onCheckboxChange}
                defaultChecked={value}
                {...rest}
            />
        </Form.Field>
    )
}

CheckboxWrapper.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool,
    label: PropTypes.string,
}

export default CheckboxWrapper;